const API = {
  COST: "/web/v3/user/expenditure",
};

export default API;
